import React from 'react';
import { Shield, Award, Target, Lock } from 'lucide-react';
import './About.css';

const About = () => {
  const values = [
    {
      icon: <Shield size={32} />,
      title: 'Approche réaliste',
      description: 'Comprendre votre surface d\'attaque, simuler un attaquant réaliste, puis livrer un rapport orienté correction et réduction de risque.'
    },
    {
      icon: <Award size={32} />,
      title: 'Expérience concrète',
      description: 'Expérience pentest web & API via missions et bug bounty (reporting, recommandations, collaboration avec équipes techniques).'
    },
    {
      icon: <Target size={32} />,
      title: 'Vision globale',
      description: 'Background systèmes/réseaux/sécurité (VLAN, DMZ, firewall, AD, vSphere), utile pour raisonner "de bout en bout" côté SI.'
    },
    {
      icon: <Lock size={32} />,
      title: 'Éthique & confidentialité',
      description: 'Respect strict de la confidentialité et de la disclosure responsable dans toutes mes interventions.'
    }
  ];

  return (
    <main className="about-page">
      <section className="page-hero">
        <div className="container">
          <h1 className="page-title">À propos</h1>
          <p className="page-subtitle">
            Pentester freelance basé à Angers, spécialisé en sécurité applicative.
          </p>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <div className="about-intro">
            <div className="about-photo-placeholder">
              <Shield size={80} />
              <p>Photo à venir</p>
            </div>
            <div className="about-text">
              <h2 className="about-name">Vianney Soulard</h2>
              <p className="about-role">Pentester Freelance</p>
              <p className="about-description">
                Je suis Vianney Soulard, pentester freelance basé à Angers (France). 
                Mon approche : comprendre votre surface d'attaque, simuler un attaquant réaliste, 
                puis livrer un rapport orienté correction et réduction de risque.
              </p>
              <p className="about-description">
                Diplômé ingénieur (ESEO, 2020–2025), j'ai développé une expertise en pentest web et API 
                à travers des missions concrètes et des activités de bug bounty. Mon background en 
                administration systèmes et réseaux me permet d'avoir une vision globale de la sécurité 
                des systèmes d'information.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="section values-section">
        <div className="container">
          <h2 className="section-title">Points clés</h2>
          <div className="values-grid">
            {values.map((value, index) => (
              <div key={index} className="value-card">
                <div className="value-icon">{value.icon}</div>
                <h3 className="value-title">{value.title}</h3>
                <p className="value-description">{value.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </main>
  );
};

export default About;